import { Injectable } from '@angular/core';
import {Scoreboard, UserScore} from "../core/models/models";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ScoreboardService {

  constructor(private httpClient: HttpClient) { }

  async getScoreboardOverall(): Promise<Scoreboard> {
    return firstValueFrom(this.httpClient.get<Scoreboard>(environment.apiUrl + "scoreboard/overall"));
  }

  async getScoreboardOverallWithLastKey(lastKey: string): Promise<Scoreboard> {
    return firstValueFrom(this.httpClient.get<Scoreboard>(environment.apiUrl + `scoreboard/overall/${lastKey}`));
  }

  async getScoreboardForLeague(league: string): Promise<Scoreboard> {
    return firstValueFrom(this.httpClient.get<Scoreboard>(environment.apiUrl + `scoreboard/league/${league}`));
  }

  async getScoreboardForLeagueWithLastKey(league: string, lastKey: string): Promise<Scoreboard> {
    return firstValueFrom(this.httpClient.get<Scoreboard>(environment.apiUrl + `scoreboard/league/${league}/${lastKey}`));
  }

  async getScoreboardForEvent(event_uuid: string): Promise<Scoreboard> {
    return firstValueFrom(this.httpClient.get<Scoreboard>(environment.apiUrl + `scoreboard/event/${event_uuid}`));
  }

  async getScoreboardForEventWithLastKey(event_uuid: string, lastKey: string): Promise<Scoreboard> {
    return firstValueFrom(this.httpClient.get<Scoreboard>(environment.apiUrl + `scoreboard/event/${event_uuid}/${lastKey}`));
  }

  async getUserScoreOverall(): Promise<UserScore> {
    return firstValueFrom(this.httpClient.get<UserScore>(environment.apiUrl + "scoreboard/user"));
  }

  async getUserScoreEvent(event_uuid: string): Promise<UserScore> {
    return firstValueFrom(this.httpClient.get<UserScore>(environment.apiUrl + `scoreboard/user/event/${event_uuid}`));
  }

  async getUserScoreLeague(league: string): Promise<UserScore> {
    return firstValueFrom(this.httpClient.get<UserScore>(environment.apiUrl + `scoreboard/user/league/${league}`));
  }


}
